const SET_USER_ADDRESS = "SET_USER_ADDRESS"

export const setUserAddress = (payload) => {
    return {
        type: SET_USER_ADDRESS,
        payload
    };
};